import { render, staticRenderFns } from "./TopFundsFormView.vue?vue&type=template&id=cc01945c&scoped=true"
import script from "./TopFundsFormView.vue?vue&type=script&lang=js"
export * from "./TopFundsFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc01945c",
  null
  
)

export default component.exports